const setupArticles = () => {
  // get all reference from content
  function getReferencesFromContent(content) {
    const refID = [];
    const refsHash = content.textContent.match(/(REF#[0-9]*)/g);

    if (refsHash == null) {
      return refID;
    } else {
      const refs = content.textContent.match(/(REF#[0-9]*)/g).map(function (ref) {
        return parseInt(ref.split('#')[1]);
      });

      // remove duplicate id
      const uniqueArray = [];
      for (let i = 0; i < refs.length; i++) {
        if (uniqueArray.indexOf(refs[i]) === -1) {
          uniqueArray.push(refs[i]);
        }
      }

      // set index for id
      let i = uniqueArray.length;
      uniqueArray
        .sort(function (a, b) {
          return b - a;
        })
        .forEach(function (id) {
          refID.push({
            id,
            index: i--,
          });
        });
    }

    return refID;
  }

  // generate reference from tags
  function generateContent(content, refList, refIDs) {
    let modifiedContent = content.innerHTML;
    refIDs.forEach(function (ref) {
      const refHash = 'REF#' + ref.id;
      const regex = new RegExp(refHash, 'g');
      modifiedContent = modifiedContent.replace(regex, createSupElement(refList, ref));
    });
    content.innerHTML = modifiedContent;
  }

  // create superscript element
  function createSupElement(refList, ref) {
    let content = '';
    const refItem = refList.querySelector('[data-reference-id="' + ref.id + '"] .blog-reference-sup');

    if (refItem) {
      content = refItem.innerHTML;
    }
    return content;
  }

  // rearrange reference and hide unused reference
  function referenceListRearrange(refIDs, refList) {
    const listItems = refList.querySelectorAll('li');
    listItems.forEach(function (item) {
      refIDs.forEach(function (ref) {
        if (item.getAttribute('data-reference-id') == ref.id) {
          item.classList.add('show-reference');
        }
      });
    });

    const sortedList = refList.querySelectorAll('li.show-reference');
    sortedList.forEach(function (item, index) {
      item.querySelector('.blog-reference .blog-reference__id').innerHTML = index + 1 + '.';
      item.querySelector('.blog-reference-sup .reference__sup').innerHTML = index + 1;
      item.querySelector('.blog-reference-sup .blog-reference__id').innerHTML = index + 1 + '.';
    });
  }

  // clear REF#... from article content
  function clearReferenceFromContent() {
    const content = document.querySelector('.article-content .article-content-main');
    const refsID = getReferencesFromContent(content);
    let modifiedContent = content.innerHTML;

    refsID.forEach(function (ref) {
      const refHash = 'REF#' + ref.id;
      const regex = new RegExp(refHash, 'g');
      modifiedContent = modifiedContent.replace(regex, '');
    });
    content.innerHTML = modifiedContent;
  }

  // display reference on hover element
  function createDisplayOnHover(content) {
    const references = content.querySelectorAll('.reference');
    references.forEach(function (ref) {
      ref.addEventListener('mouseover', function () {
        const windowWidth = document.querySelector('body').clientWidth;
        this.classList.add('active');
        const refContent = this.querySelector('.reference__content');
        const position = getReferencePosition(refContent);

        if (position.right > windowWidth) {
          refContent.style.left = windowWidth - position.right - 5 + 'px';
        } else if (position.left < 0) {
          refContent.style.left = Math.abs(position.left) + 10 + 'px';
        }
      });

      ref.addEventListener('mouseout', function () {
        const refContent = this.querySelector('.reference__content');
        this.classList.remove('active');
        refContent.removeAttribute('style');
      });
    });
  }

  // get position of reference content
  function getReferencePosition(refContent) {
    const rect = refContent.getBoundingClientRect();
    return {
      left: rect.left + window.scrollX,
      right: rect.right + window.scrollX,
    };
  }

  // init blog citations
  function init() {
    const refList = document.querySelector('ul.bm-blog-references');
    if (refList) {
      const content = document.querySelector('.article-content .article-content-main');
      const refIDs = getReferencesFromContent(content);
      referenceListRearrange(refIDs, refList);
      generateContent(content, refList, refIDs);
      createDisplayOnHover(content);
    } else {
      clearReferenceFromContent();
    }
  }

  init();
};

setupArticles();
